import disputeRepository from '@/domain/repository/DisputeRepository';
import {Dispute, toDomain} from '@/domain/entities/Dispute';

export const getDisputeForParcel = async (parcelUuid: string): Promise<Dispute | undefined> => {
  try {
    const disputes = await disputeRepository.getDisputesForParcel(parcelUuid);
    const dispute = disputes[0];

    if(dispute) {
      return toDomain(dispute);
    }
  } catch (error) {
    console.error('Error fetching dispute', error);
    return undefined;
  }
};